import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../../components/form-controls/Button";
import Input from "../../../components/form-controls/Input";
import { SubAccountService } from "../../../services/SubaccountService";
import Select from "../../../components/form-controls/Select";
import { AlertService } from "../../../services/Alert";
import TextArea from "../../../components/form-controls/TextArea";
import { TemplatesService } from "../../../services/TemplatesService";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import useModal from "../../../hooks/useModal";
import { useTranslation } from "react-i18next";
interface FormModalProps {
    show: boolean;
    onRequestClose: (reload: boolean) => void;
    template: any;
}

function FormModal({ show, onRequestClose, template }: FormModalProps) {

    const { t } = useTranslation();

    const { account } = useCurrentAccount();
    
    const modalSubRef = useRef<HTMLDivElement>(null);

    useModal(modalSubRef, show)

    const [subaccounts, setsubaccounts] = useState<any>([]);

    const defaultValues = {
        templete_id: 0,
        account_id: '',
        sub_account: '',
        sub_account_id: '',

        type: '',

        title: '',
        image: '',
        // file: '',
        text: '',
    }

    const { register, handleSubmit, watch, reset, setValue, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const type = watch('type')

    const closeAndReset = async (reload: boolean) => {
        await onRequestClose(reload);
        reset(defaultValues);
    }

    const submit = async (data) => {
        if(data.templete_id) {
            await handleUpdateTemplate(data)
        } else {
            await handleSaveTemplate(data)
        }
    }

    const handleUpdateTemplate = async(data) => {
        try {
            let form: any = {
                templete_id: data.templete_id,
                title: data.title,
                sub_account_id: data.sub_account_id,
                sub_account: '',
            }

            if(data.sub_account_id) {
                const findSubaccount = subaccounts.find( s => +s.id === +data.sub_account_id )
                form.sub_account = findSubaccount.name;
            }
            

            if(template.type === 'TXT' ) {
                form.text = data.text;
                await updateTemplate('updateTextTemplate', form)
            } else {
                await updateTemplate('updateFileTemplate', form)
            }

            await closeAndReset(true)
            AlertService.success('¡Éxito!', "Se actualizó correctamente la plantilla")
        } catch (error) {
            console.error(error);
            AlertService.error('¡Error!',  'No se pudo actualizar la plantilla, intenta más tarde')
        }
    }

    const handleSaveTemplate = async(data) => {
        try {
            const form = new FormData();

            form.append('account_id', account.id);
            form.append('title', data.title);
            form.append('sub_account_id', data.sub_account_id);

            if(data.sub_account_id) {
                const findSubaccount = subaccounts.find( s => +s.id === +data.sub_account_id )
                data.sub_account = findSubaccount.name;
            } else {
                data.sub_account = ''
            }
            
            form.append('sub_account', data.sub_account);

            if(data.type === 'text') {
                form.append('text', data.text);
                await saveTemplate('saveTextTemplate', form)
            } else if(data.type === 'image') {
                form.append('image', data.image[0]);
                await saveTemplate('saveImageTemplate', form)
            } else if(data.type === 'file') {
                form.append('image', data.image[0]);
                await saveTemplate('saveFileTemplate', form)
            }

            await closeAndReset(true)
            AlertService.success('¡Éxito!', "Se guardó correctamente la plantilla")
        } catch (error) {
            console.error(error);
            AlertService.error('¡Error!',  'No se pudo guardar la plantilla, intenta más tarde')
        }
    }

    const saveTemplate = async(action: 'saveTextTemplate' | 'saveImageTemplate' | 'saveFileTemplate', form: FormData) => {
        const { data } = await TemplatesService[action](form)
        console.log(data)
    }

    const updateTemplate = async(action: 'updateTextTemplate' | 'updateFileTemplate' , form: any) => {
        const { data } = await TemplatesService[action](form)
        console.log(data)
    }

    const acceptedFormats = (value) => {
        const file = value[0];
        const ext = file.name.split('.').pop()

        if(type === 'image' && ['jpg','jpeg', 'png'].indexOf(ext) === -1) {
            return 'Solo se aceptan imágenes en formato jpg, jpeg o png'
        }
        
        return true;
    }

    const getSubaccounts = async() => {
        const { data } =  await SubAccountService.getSubaccounts(account.id)
        setsubaccounts(data.sub_accounts)
    }

    useEffect(() => {
        if(template) {
            reset({
                templete_id: template.id,
                sub_account_id: template.sub_account_id,
                type: template.type === 'TXT' ? 'text':  template.type === 'IMG' ? 'image': 'file' ,
                title: template.title,
                text: template.text,
            })
        }
        
    }, [template])

    useEffect(() => {
        if(!template) {
            setValue('image', '')
            setValue('text', '')
        }
    }, [type])

    useEffect(() => {
        getSubaccounts()
    }, []);


    return (
        <div className="modal fade" ref={modalSubRef} data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog" role="document">
                <form onSubmit={handleSubmit(submit)}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">{template ? t("config.templates.edit"): t("config.templates.create")} {t("config.templates.template-text")}</h4>
                            <button type="button" className="btn-close" onClick={() => closeAndReset(false)}></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <Input label={t("config.templates.template-name")} errors={errors.title} {...register('title', { required: true })} />
                            </div>
                            {
                                !template && (
                                    <div className="mb-3">
                                        <Select
                                            label={t("config.templates.template-type")}
                                            data={[
                                                {value: '', text: t("config.templates.select-template"),  disabled: true  },
                                                {value: 'text', text: t("config.templates.text-template") },
                                                {value: 'image', text: t("config.templates.image-template") },
                                                {value: 'file', text: t("config.templates.document-template") },
                                            ]}
                                            errors={errors.type}
                                            {...register('type',  { disabled: template ? true: false })}
                                        />
                                    </div>
                                )
                            }
                            
                            {
                                (template?.type === 'TXT' || type === 'text') && (
                                    <div className="mb-3">
                                        <TextArea
                                            label={t("config.templates.text-label")}
                                            errors={errors.text}
                                            {...register('text', { required: true })} 
                                        />
                                    </div>
                                )
                            }
                            {
                                !template && (type === 'image' || type === 'file') && (
                                    <div className="mb-3">
                                        <Input label={t("config.templates.select-file")} type={'file'} errors={errors.image} {...register('image', { required: true, validate: { custom: acceptedFormats} })} />
                                    </div>
                                )
                            }
                            
                            <div className="mb-3">
                                <Select
                                    label={<>{t("config.templates.subaccount-label")} <span className="form-label-secondary">({t("config.templates.optional-label")}) </span></>}
                                    data={ [{value: '', text: t("config.templates.no-subaccount") }].concat(subaccounts.map( a => ({ value: a.id, text: a.name }))) }
                                    errors={errors.sub_account_id}
                                    {...register('sub_account_id')}
                                />
                            </div>

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-white btn-sm" onClick={() => closeAndReset(false)}>{t("btn-cancel")}</button>
                            <Button type="submit" className="btn btn-primary btn-sm" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>{t("btn-save")}</Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default FormModal